"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VISIBLE_SOCIALS_COUNT = exports.SOCIAL_NETWORKS = exports.INITIALLY_EXPANDED_SOCIALS_LIMIT = void 0;
var _social = require("../../types/social");
const SOCIAL_NETWORKS = exports.SOCIAL_NETWORKS = [_social.ESocialType.MailRu, _social.ESocialType.VK, _social.ESocialType.AppleID, _social.ESocialType.OK, _social.ESocialType.Gosuslugi, _social.ESocialType.Google, _social.ESocialType.Facebook];
const VISIBLE_SOCIALS_COUNT = exports.VISIBLE_SOCIALS_COUNT = 3;

// Если сейчас доступно INITIALLY_EXPANDED_SOCIALS_LIMIT соц сетей,
// то нет смысла скрывать их под кнопкой "раскрыть", показываем все сразу
const INITIALLY_EXPANDED_SOCIALS_LIMIT = exports.INITIALLY_EXPANDED_SOCIALS_LIMIT = 5;